
<!--img class="control-loader" *ngIf="loading" src="/assets/css/images/platform/loader.gif" /-->
<sem-loader [showLoader]="loading"></sem-loader>

@for (imgUrl of imageUrls; track imgUrl) {
  <div class="sem-image-container">
    <div class="actual-image" [ngStyle]="{'background-image': 'url(' + imgUrl + ')', 'width':getSpecifiedWidth(), 'height':getSpecifiedHeight()}"></div>
    <!--img [src]="imgUrl" />-->
  </div>
}